import React, {
  ElementType,
  ComponentPropsWithoutRef,
  forwardRef,
} from "react";
import PropTypes from "prop-types";

import styles from "./Notification.scss";

export type NotificationCopyTextProps<
  Tag extends ElementType = NotificationCopyTextDefaultTag
> = {
  tag?: Tag;
} & ComponentPropsWithoutRef<Tag>;

export const NotificationCopyTextDefaultTagName = "p";
export type NotificationCopyTextDefaultTag = typeof NotificationCopyTextDefaultTagName;

// eslint-disable-next-line tree-shaking/no-side-effects-in-initialization
export const NotificationCopyText = forwardRef<
  HTMLParagraphElement,
  NotificationCopyTextProps<ElementType>
>(
  (
    {
      children,
      tag: CustomTag = NotificationCopyTextDefaultTagName,
      ...restProps
    },
    ref
  ) => (
    <CustomTag ref={ref} className={styles.copytext} {...restProps}>
      {children}
    </CustomTag>
  )
);

NotificationCopyText.propTypes = {
  tag: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

NotificationCopyText.defaultProps = {
  tag: NotificationCopyTextDefaultTagName,
};

NotificationCopyText.displayName = "Notification.CopyText";

export default NotificationCopyText;
